<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style >
.bottomBar {
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.bottomBar > .pagination {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue